import { mainLocator as locator } from '@core/di/main.locator';
import { SequenceRepository } from '@core/sequence.repository';
import { UiService } from '@core/services/ui.services';
import CashBookRepository from '@modules/chefs-assistant/pages/cash-book/cash-book.repository';
import { CashBookStore } from '@modules/chefs-assistant/pages/cash-book/cash-book.store';

locator.register('CashBookRepository', CashBookRepository);
locator.registerInstance(
  'CashBookStore',
  new CashBookStore(
    locator.resolve<UiService>('UiService'),
    locator.resolve<SequenceRepository>('SequenceRepository'),
    locator.resolve<CashBookRepository>('CashBookRepository'),
  ),
);
